var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gamesnest-app",attrs:{"id":"app"}},[_c('Header'),_c('main',{staticClass:"main-content"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }